import { WebSocketEntityUpdateInterface } from '@/utils/websocket-entity-updates/webSocketEntityUpdates.types';
import { store } from '@/redux/store';
import { ENTITY_OPERATION_TYPES } from '@/utils/websocket-entity-updates/webSocketEntityUpdates.constants';
import { getProjectById } from '@/redux/project/project.thunks';
import { refreshProjectOnList } from '@/redux/projects/projects.thunks';
import { deleteProject } from '@/redux/projects/projects.slice';

/**
 * Keeps the list of projects in sync with the server without polling it. Project events are
 * sent to every admin/curator session, so the list is updated no matter who triggered the change.
 */
export default async function processProject({
  data,
}: {
  data: WebSocketEntityUpdateInterface;
}): Promise<void> {
  const { dispatch } = store;

  if (data.type === ENTITY_OPERATION_TYPES.ENTITY_CREATED) {
    dispatch(getProjectById(data.projectId));
  } else if (data.type === ENTITY_OPERATION_TYPES.ENTITY_UPDATED) {
    // a project removal sends ENTITY_UPDATED (status -> removing) shortly before ENTITY_DELETED;
    // refreshing must not put the project back on the list if the delete won the race
    dispatch(refreshProjectOnList(data.projectId));
  } else if (data.type === ENTITY_OPERATION_TYPES.ENTITY_DELETED) {
    dispatch(deleteProject(data.projectId));
  }
}
